import { ISelectOption } from '../interfaces/select-option.interface';

export const CHART_TYPES: ISelectOption[] = [
  { key: 'bar-horizontal', name: 'Horizontal Bars' },
  { key: 'bar-vertical', name: 'Vertical Bars' },
  { key: 'pie-chart', name: 'Pie' },
];
